import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Pagination from '@material-ui/lab/Pagination';
import React, { Fragment, useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactLoading from 'react-loading';
import Select from 'react-select';
import BtnExcel from '../BtnExcel';
import { formatDate, getBranch, getRoleId, getTodayDate, numberFormat } from "../../../utilities/common";

// css
import '../../common.css';
import "../reports/daily-sales-report.css";

// components
import Navbar from '../../navbar';
import TableTemplate from '../../table-template';

// sample data (temp)
import { getBookingDetail } from "../../../utilities/api_calls/bookingDetailsApi";
import { 
  getAllBranches, 
  // getBranchName 
} from '../../../utilities/api_calls/branchApi';
import { getSummary } from "../../../utilities/api_calls/paymentApi";
import { exportSalesListExcel, getSalesList } from '../../../utilities/api_calls/reports/dailySalesReportApi';
import NoDataPrompt from "../../../utilities/no-data-prompt";

export default function DailyTransactions() {
  function getDefaultFilter() {
    return {
      branch: getRoleId() === "4" ? "" : getBranch().replace(/['"]+/g, ''),
      type: "",
      date_from: getTodayDate(),
      date_to: getTodayDate(),
      search: '',
      page: 1,
    };
  }

  const [showLoader, setShowLoader] = useState(true);
  const [totals, setTotals] = useState({});

  // Pagination
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // select Items
  const [clear, setClear] = useState(true);
  // const [itemOptions, setItemOptions] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [excelList, setExcelList] = useState([]);
  const [value, setValue] = useState({});
  const [customerName, setCustomerName] = useState("");
  const [branches, setBranches] = useState([]);

  const options = [
    { label: "All Types", value: "" },
    { label: "Cash", value: "cash" },
    { label: "Debit/Credit Card", value: "card" },
    { label: "Bank Transfer", value: "bank_transfer" },
    { label: "Online", value: "online" }
  ];

  const [filter, setFilter] = useState(getDefaultFilter());
  const [appliedFilter, setAppliedFilter] = useState(getDefaultFilter());

  const handleFilterType = (e) => {
    setClear(false)
    setFilter(prevState => ({
      ...prevState,
      type: e.value,
    }));
    setValue({ label: e.label, value: e.value })
  };

  function handlePageChange(event, value) {
    setAppliedFilter((prev) => ({
      ...prev,
      page: value,
    }))
    setCurrentPage(value)
  };

  async function fetchSalesList() {
    setShowLoader(true);
    const response = await getSalesList({
      ...appliedFilter,
      customer: customerName
    });
    if(response.data){
      let num_pages = Math.ceil(response.data.data.size / 10);
      setPages(num_pages);
      let sales_list = response.data.data.sales.map((data) => ({
        ...data,
        payment_type: data.payment_type === "bank_transfer" ? "Bank Transfer" :  data.payment_type === "gift_certificate" ? "Gift Certificate" : data.payment_type
      }))
      setSalesList(sales_list);
      setTotals(response.data.data.total_sales)
    } else {
      setPages(1);
      setSalesList([]);
      setTotals({})
    }
    setShowLoader(false);
  };

  async function exportSalesList() {
    setShowLoader(true);

    const response = await exportSalesListExcel({
      date_from: appliedFilter.date_from,
      date_to: appliedFilter.date_to,
      branch: appliedFilter.branch,
      type: appliedFilter.type,
      customer: customerName,
    });

    if (response?.data) {
      const blob = new Blob([response.data], {
        type: response?.headers?.['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Daily_Transaction.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setShowLoader(false);
      return { ok: true };
    }

    setShowLoader(false);
    return { ok: false };
  };

  //Get all branches
  async function fetchBranches() {
    const response = await getAllBranches();
    setBranches(response.data.data.branches);
  }

  // -- Filter Functions --- //
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleDateFromChange = (date) => {
    setFilter(prevState => ({
      ...prevState,
      date_from: date,
    }))
  }

  const handleDateToChange = (date) => {
    setFilter(prevState => ({
      ...prevState,
      date_to: date,
    }))
  }

  function removeFilter() {
    const clearedFilter = {
      branch: getRoleId() === "4" ? "" : getBranch().replace(/['"]+/g, ''),
      type: "",
      date_from: "",
      date_to: "",
      search: "",
      page: 1
    };
    setFilter(clearedFilter);
    setAppliedFilter(clearedFilter);
    setCurrentPage(1);
    setClear(true)
  }

  function handleSearch() {
    setCurrentPage(1);
    setAppliedFilter({
      ...filter,
      page: 1,
    });
  }

  // view button
  const [showSummary, setShowSummary] = useState(false);
  const handleCloseSummary = () => setShowSummary(false);
  const handleShowSummary = () => setShowSummary(true);

  const [existingSummary, setExistingSummary] = useState([{
    date: "",
    id: "",
    name: "",
    quantity: "",
    total_price: "",
  }]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  // const [branch, setBranch] = useState("");
  // const [orNo, setOrNo] = useState([]);
  const [footer, setFooter] = useState({total: 0, balance: 0});
   const [amountSummary, setAmountSummary] = useState({});
  // const [subTotal, setSubTotal] = useState(0);
  // const [discount, setDiscount] = useState(0);
  // const [grandTotal, setGrandTotal] = useState(0)
  const [selectedDetails, setSelectedDetails] = useState([{
    date_booked: "",
    remarks: "",
  }])
  async function viewExistingSummary(id, booking_deets) {
    // var subTotal = 0;
    const response = await getSummary(id, booking_deets.branch_id);
    if(response.data){
      setAmountSummary(response.data.data)
      // setBranch(response.data.data.booked_at);
      // setOrNo(response.data.data.or_no);
      setExistingSummary(response.data.data.summary)
      setPaymentHistory(response.data.data.payment_history === 0 ? [] : response.data.data.payment_history)
      let payments = response.data.data.payment_history;
      let total = 0;
      payments && payments.map((payment) => {
        total += parseFloat(payment.paid_amount);
      })
      // setSubTotal(response.data.data.sub_total);
      // setGrandTotal(response.data.data.grand_total);
      // setDiscount(response.data.data.discount)
      setFooter({total: total, balance: response.data.data.balance})
  
      // response.data.data.summary.map((data) => {
      //   return (subTotal += parseFloat(data.total_price))
      // })
  
    } else {
      setAmountSummary({})
      // setBranch("");
      // setOrNo([]);
      setExistingSummary([])
      setPaymentHistory([])
      // setSubTotal(0);
      // setGrandTotal(0);
      // setDiscount(0)
  
      setFooter({total: 0, balance: 0})
    }
  }

  function renderTable() {
    if (salesList.length === 0) {
      return (
        <NoDataPrompt text="sales" />
      )
    } else {
      return (
        <div className='sales-render-table'>
          <TableTemplate
            tableType='sample_daily_sales_report'
            tableHeaders={["Date", "Customer", "Booking #","Session", "Subtotal", "Discount", "Grand Total", "Paid Amount", "Balance", "Payment Type", "Action"]}
            tableData={salesList}
            hasFooter={true}
            footerData={totals}
            tableFuncs={[null, null, null, [onclickSummary]]}
            currentPage={currentPage}
          />

          <Pagination 
            count={pages}
            page={currentPage} 
            shape="rounded" 
            defaultPage={1} 
            siblingCount={2} 
            onChange={handlePageChange} 
            showFirstButton 
            showLastButton 
          />
        </div>
      )
    }
  }

  const [showLoaderModal, setShowLoaderModal] = useState(false)

  async function onclickSummary(id, row) {
    handleShowSummary();
    setShowLoaderModal(true)
    const booking_deets = await getBookingDetail(id);

    setSelectedDetails({ date_booked: row.date, customer: row.customer })
    viewExistingSummary(id, booking_deets);
    setShowLoaderModal(false)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  React.useEffect(() => {
    fetchSalesList();
    // eslint-disable-next-line
  }, [appliedFilter]);

  React.useEffect(() => {
    fetchBranches();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div>
        <Navbar />
        <div className="active-cont">
          <Fragment>

            <div className="d-flex flex-row justify-content-between align-items-center cont-section">
              <h1 className="cont-sect-header">Daily Transactions</h1>
              <div className="search-wrapper w-50">
                <input 
                  type="search" 
                  className="form-control search-indent" 
                  name="search" 
                  value={customerName} 
                  onChange={(e) => setCustomerName(e.target.value)} 
                  onKeyDown={handleKeyPress}
                  placeholder="Search by Customer Name" 
                />
                <div className="search-icon">
                  <FontAwesomeIcon
                    className="icon"
                    icon={'search'}
                    aria-hidden="true"
                    alt={'search'}
                    fixedWidth
                    onClick={handleSearch}
                  />
                </div>
              </div>
            </div>

            {/** FILTER */}
            <div className="filter-cont mt-0">
              <div className="filter-label-row1">FILTER BY:
                {getRoleId() === "4" ?
                  <select className="filter-dropdown-input" name="branch" value={filter.branch} onChange={(e) => handleFilterChange(e)}>
                    <option selected value="">All Branches</option>
                    {
                      branches.map((branch) => {
                        return (<option key={branch.id} value={branch.id}>{branch.name}</option>)
                      })}
                  </select> : null}
                <Select 
                  className="react-select-container" 
                  classNamePrefix="react-select" 
                  value={clear ? options[0] : value} 
                  placeholder="Select Payment Type..." 
                  options={options} 
                  onChange={(e) => handleFilterType(e)} 
                />
                {/* <select className="filter-dropdown-input" name="type" value={filter.type} onChange={(e) => handleFilterChange(e)}>
                  <option value="" hidden>All Types</option>
                  <option value="cash">Cash</option>
                  <option value="card">Debit/Credit</option>
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="online">Online</option>
                </select> */}
              </div>
              <div className='filter-label-row1'>
                DATE FROM:
                <DatePicker selected={filter.date_from} dateFormat="MM/dd/yyyy" className="filter-date-picker mx-3 px-1" name="date_from" placeholderText="mm/dd/yyyy" onChange={date => handleDateFromChange(date)} />
                {/* <input type="date" className="filter-date-picker" name="date_from" value={filter.date_from} onChange={(e) => handleFilterChange(e)} /> */}

                TO:
                <DatePicker selected={filter.date_to} dateFormat="MM/dd/yyyy" className="filter-date-picker mx-3 px-1" name="date_to" placeholderText="mm/dd/yyyy" onChange={date => handleDateToChange(date)} />
                {/* <input type="date" className="filter-date-picker" name="date_to" value={filter.date_to} onChange={(e) => handleFilterChange(e)} /> */}

                <div className="btn-conf-wrapper in-line  remove-filter-btn">
                  <Button type="button" className="px-2 py-1 mtn-1" onClick={handleSearch}>Search</Button>
                </div>
                <div className="btn-conf-wrapper in-line  remove-filter-btn">
                  <Button type="button" className="px-2 py-1 mtn-1" onClick={() => removeFilter()}>Remove Filter</Button>
                </div>
                <div
                  className="btn-conf-wrapper in-line  remove-filter-btn"
                >
                  <BtnExcel
                    label={"Export to Excel"}
                    size={"sm"}
                    excelData={excelList}
                    xlsxHeaders={[
                      "Date",
                      "Customer",
                      "Booking #",
                      "Session",
                      "Subtotal",
                      "Discount",
                      "Grand Total",
                      "Paid Amount",
                      "Balance",
                      "Payment Type",
                    ]}
                    handleData={exportSalesList}
                    isClicked={showLoader}
                    fileName={`Daily_Transaction.xlsx`}
                  />
                </div>
              </div>
            </div>

            {/* <div className="cont-section-novertpad sales-table"> */}
            <div className="new-sales-table">
              <div>
                {
                  showLoader ? 
                    <ReactLoading 
                      type="spinningBubbles" 
                      color="#d4271c" 
                      height={200} 
                      width={100} 
                      className='list-loader' 
                    />
                  : 
                    renderTable()
                }
              </div>
            </div>


          </Fragment>
          <Modal show={showSummary} onHide={() => { handleCloseSummary() }} size="lg" className="custom-modal-style" centered>
            <Modal.Header className="custom-modal-header d-flex justify-content-end" closeButton></Modal.Header>
            {showLoaderModal ?
              <ReactLoading type="spinningBubbles" color="#d4271c" height={150} width={100} className='modal-loader' />
              : <>
                <Modal.Body className="px-5 py-1 flex-column">
                  <div className=" flex-row">
                    <Container className="col-5 my-auto">
                      <Row><div className="h1 fw-bold my-0">Summary</div></Row>
                      <Row><div className="h7 my-0">BRANCH: {amountSummary.booked_at}</div></Row>
                      <Row><div className="h7 my-0">DATE:  {formatDate(selectedDetails.date_booked)}</div></Row>
                      <Row><div className='h7 my-0'>CUSTOMER: {selectedDetails.customer}</div></Row>
                      
                      {/* <Row><div className="h7 my-0">REMARKS: {selectedDetails.REMARKS}</div></Row> */}
                    </Container>

                    <div className="custom-modal-vertline-border mx-3"></div>

                    <Container className="my-auto">
                      {existingSummary && existingSummary.map((data, index) => {
                        return <Row className='nc-modal-custom-row my-1'>
                        <Col xs={1}>{data?.quantity}</Col>
                        <Col xs={4} className="fw-bold">{data?.code ? (data?.code + "-") : ""}{data?.name ? data?.name : ""}</Col>
                        <Col xs={3} className="fw-bold">{data?.total_price ? data?.total_price : ""}</Col>
                        <Col xs={4} className="fw-bold">{data?.commissioner || "-"}</Col>
                        </Row>
                      })}

                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"> </Col>
                        <Col xs={5} className="fw-bold"> </Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='nc-modal-custom-row my-1'>
                        <Col xs={7} className="fw-bold"></Col>
                        <Col xs={5} className="fw-bold"></Col>
                      </Row>
                      <Row className='my-1'>
                        <Row className="nc-modal-custom-row my-1">
                          <Col xs={5} className="fw-bold">Sub-Total</Col>
                          <Col xs={5} className="fw-bold">{amountSummary.sub_total}</Col>
                        </Row>
                        <Row className="nc-modal-custom-row my-1">
                          <Col xs={5} className="fw-bold">Discount</Col>
                          <Col xs={5} className="fw-bold">{amountSummary.discount}</Col>
                        </Row>
                        <Row className="nc-modal-custom-row my-1">
                          <Col xs={5} className="fw-bold">Grand Total</Col>
                          <Col xs={5} className="fw-bold">{amountSummary.grand_total}</Col>
                        </Row>
                        <Row className="nc-modal-custom-row my-1">
                          <Col xs={5} className="fw-bold">OR NO.</Col>
                          <Col xs={5} className="fw-bold">
                          <Col xs={5} className="fw-bold">{amountSummary.or_no == null || amountSummary.or_no.length === 0 ? "NONE" : amountSummary.or_no}</Col>

                            {/* {orNo == null || orNo.length === 0 ? "NONE" : orNo.map((data, index) => {
                            if(orNo.length - 1 === index) {
                                return <span>{data.OR_NO}</span>
                              } else {
                                return <span>{data.OR_NO}, </span>
                              }
                            })} */}
                        </Col>
                        </Row>
                        {/* <Row className="nc-modal-custom-row my-1">
                        <Col xs={10} className="fw-bold">COMMISSIONED BY: <br />
                          <h6 className="fw-bold px-5">{existingSummary[0].commissioner}</h6>
                        </Col>
                      </Row> */}
                      </Row>
                    </Container>
                  </div>

                  <hr className="text-danger" />

                  <div className="d-flex flex-column">
                    <div className="h5 my-0 mb-3 text-uppercase fw-bolder">Payment History</div>

                    <div>
                      <TableTemplate 
                        tableType="sales_payment_history"
                        tableHeaders={["DATE", "PAYMENT TYPE", "PAID AMOUNT", "REMARKS"]}
                        tableData={paymentHistory}
                        hasFooter={true}
                        footerData={footer}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="border-0 px-5">
                  <div className="d-flex flex-row justify-content-between">
                    <div className="btn-conf-wrapper ms-auto">
                    </div>
                  </div>
                </Modal.Footer>
              </>}
          </Modal>

        </div>
      </div>
    </>
  );
}